import { OnboardingTooltip, TPlacement } from '@cian/ui-kit';
import * as React from 'react';
import { BuilderChatOnboardingContent } from 'shared/components/BuilderChatOnboardingContent';
import { TBuilderChatOnboardingType } from 'shared/types/chatOnboarding';

import { useBuilderChatOnboarding } from './hooks/useBuilderChatOnboarding';

interface IBuilderChatOnboardingContainerProps {
  children: React.ReactElement;
  type: TBuilderChatOnboardingType;
  placement: TPlacement;
  wide?: boolean;
}

// TODO: Удалить в CD-226143.
export const BuilderChatOnboardingContainer: React.FC<IBuilderChatOnboardingContainerProps> = ({
  children,
  type,
  placement,
  wide = false,
}) => {
  const { open, onboardingText, closeHandler } = useBuilderChatOnboarding(type);

  return (
    <OnboardingTooltip
      theme="black"
      content={<BuilderChatOnboardingContent wide={wide} onboardingText={onboardingText} />}
      placement={placement}
      portal={false}
      open={open}
      onClose={closeHandler}
      flip={false}
    >
      <div>{children}</div>
    </OnboardingTooltip>
  );
};
